import { ChunkReloadErrorHandler } from './core/services/chunk-reload/chunk-reload';
import { WhatsNewComponent } from './shared/components/whats-new/whats-new.component';
import { PremiumHintComponent } from './shared/components/premium-hint/premium-hint.component';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './core/guards/auth.guard';
import { MdbNotificationService } from 'mdb-angular-ui-kit/notification';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { AdminMaintenanceBannerComponent } from './components/admin-maintenance-banner/admin-maintenance-banner.component';
import { MaintenanceInfoBannerComponent } from './components/maintenance-info-banner/maintenance-info-banner.component';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaintenanceComponent,
        AdminMaintenanceBannerComponent,
        MaintenanceInfoBannerComponent,
        PremiumHintComponent,
        WhatsNewComponent], providers: [
        AuthGuard,
        // old tabs after a deploy: reload once instead of failing on a missing lazy chunk
        { provide: ErrorHandler, useClass: ChunkReloadErrorHandler },
        provideHttpClient(withInterceptorsFromDi()),
        MdbNotificationService,
        MdbModalService,
    ] })
export class AppModule {}
